import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import { FileUploader } from '@/common/components/FileUploader'
import GoBackButton from '@/common/components/GoBackButton'
import ResumeBox from '@/common/components/ResumeBox'
import { formatDecimal } from '@/common/utils/formatters'
import { getFilenameFromUrl } from '@/common/utils/getFilenameFromUrl'
import { ModalDeleteEstablishmentRequiredDocument } from '@/features/maintenance/establishmentRequiredDocuments/components/modalDeleteEstablishmentRequiredDocument'
import { useEstablishmentRequiredDocument } from '@/features/maintenance/establishmentRequiredDocuments/hooks/useEstablishmentRequiredDocument'
import { ChevronsRightIcon } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'

const Show = () => {
  const { id } = useParams()

  const {
    data: establishmentRequiredDocument,
    isPending: establishmentRequiredDocumentIsPending,
    error: establishmentRequiredDocumentError = {} as any,
    refetch: refetchPermission,
  } = useEstablishmentRequiredDocument(id || '')

  const disableUpdateButton =
    establishmentRequiredDocumentIsPending || establishmentRequiredDocumentError?.status === 403

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/establishment-required-documents" searchLastRouteFromFallback />

          <p className="text-white-400 font-normal">Documentos Obrigatórios</p>

          <ChevronsRightIcon className="text-white-400" />

          <h2>{establishmentRequiredDocument?.display_name}</h2>
        </div>

        <div className="flex gap-4">
          <ModalDeleteEstablishmentRequiredDocument />

          <Link
            to={disableUpdateButton ? '' : `/establishment-required-documents/${id}/edit`}
            className={disableUpdateButton ? 'cursor-default' : ''}
          >
            <Button
              name="update_establishment_required_document"
              operationKlassToCheckPermission="Admin::Maintenance::EstablishmentRequiredDocuments::Update"
              disabled={disableUpdateButton}
            >
              Editar
            </Button>
          </Link>
        </div>
      </div>

      {establishmentRequiredDocumentIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="h-[calc(100vh-128px)]"
          statusCode={establishmentRequiredDocumentError?.status}
          refetchFunction={refetchPermission}
        >
          <Box className="max-h-[calc(100vh-128px)] flex flex-col gap-4 overflow-y-auto">
            <p className="text-lg font-bold">Documentos Obrigatórios</p>

            <div className="flex items-start gap-x-4">
              {!!establishmentRequiredDocument?.file_sample?.url && (
                <FileUploader
                  className="w-[11rem] h-auto min-h-[100px] bg-white-100 py-4 rounded-sm"
                  fileName={
                    establishmentRequiredDocument.file_sample?.url
                      ? getFilenameFromUrl(establishmentRequiredDocument.file_sample?.url)
                      : ''
                  }
                  currentFileUrl={establishmentRequiredDocument.file_sample?.url}
                  disabled
                />
              )}

              <div className="flex-1 flex flex-col gap-y-4">
                <ResumeBox
                  boxClassName="bg-white-200"
                  label="Nome"
                  value={establishmentRequiredDocument?.display_name || '--'}
                  testId="display_name"
                />

                {!!establishmentRequiredDocument?.default_validity_in_days && (
                  <ResumeBox
                    boxClassName="bg-white-200"
                    label="Validade padrão em dias"
                    value={`${formatDecimal(establishmentRequiredDocument?.default_validity_in_days, 0)} Dia${
                      establishmentRequiredDocument?.default_validity_in_days > 1 ? 's' : ''
                    }`}
                    testId="default_validity_in_days"
                  />
                )}
              </div>
            </div>
          </Box>
        </ErrorMessageWrapper>
      )}
    </div>
  )
}

export default Show
